module.exports = __webpack_public_path__ + "img/face2face_inactive.996cea32.svg";